<div class="pia-knowledgeBaseBlock">
  <h3 style="font-weight:400;">
    {{ "knowledge_base.choose_knowledge_base" | translate }}
  </h3>

  @if (customKnowledgeBases) {
  <select
    [(ngModel)]="selectedKnowledBase"
    (change)="switch(selectedKnowledBase)"
  >
    @for (base of customKnowledgeBases; track base) { @if (base) {
    <option [value]="base.id">
      {{ base.name }}
    </option>
    } }
  </select>
  }

  <br /><br />
  <div class="pia-knowledgeBaseBlock-searchForm">
    <form (ngSubmit)="onSubmit()" [formGroup]="searchForm">
      <input type="search" formControlName="q" />
      <button
        class="btn"
        type="submit"
        title="{{ 'knowledge_base.search' | translate }}"
      >
        <fa-icon [icon]="faSearch"></fa-icon>
      </button>
    </form>
    @if (knowledgeBaseService.placeholder) {
    <div class="pia-knowledgeBaseBlock-placeholder bounceIn">
      <div>{{ "knowledge_base.placeholder_help" | translate }}</div>
      <div>{{ knowledgeBaseService.placeholder | translate }}</div>
    </div>
    }
  </div>

  @if (item && item.filter_by === 'measure') {
  <div class="pia-knowledgeBaseBlock-filters">
    <div>{{ "knowledge_base.filters.title" | translate }}</div>
    <button
      class="btn active"
      type="button"
      (click)="knowledgeBaseService.search('', $event)"
    >
      {{ "knowledge_base.filters.all" | translate }}
    </button>
    <button
      class="btn"
      type="button"
      (click)="knowledgeBaseService.search('measure.definition', $event)"
    >
      {{ "knowledge_base.filters.definitions" | translate }}
    </button>
    <button
      class="btn"
      type="button"
      (click)="knowledgeBaseService.search('measure.governance', $event)"
    >
      {{ "knowledge_base.filters.organizational_measures" | translate }}
    </button>
    <button
      class="btn"
      type="button"
      (click)="knowledgeBaseService.search('measure.data_processing', $event)"
    >
      {{ "knowledge_base.filters.measures_on_data" | translate }}
    </button>
    <button
      class="btn"
      type="button"
      (click)="knowledgeBaseService.search('measure.security', $event)"
    >
      {{ "knowledge_base.filters.general_measures" | translate }}
    </button>
  </div>
  } @if ( knowledgeBaseService.knowledgeBaseData.length > 0) {
  <div class="pia-knowledgeBaseBlock-list">
    @for (itemKb of knowledgeBaseService.knowledgeBaseData; track itemKb) {
    <app-knowledge-base-item
      [item]="item"
      [itemKb]="itemKb"
      [editMode]="editMode"
      (newMeasureEvent)="addNewMeasure($event)"
    ></app-knowledge-base-item>
    }
  </div>
  } @else {
  <div class="pia-knowledgeBaseBlock-list">
    {{ "knowledge_base.filters.no_result" | translate }}
  </div>
  }
</div>
